webpackJsonp([51],{

/***/ 1208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_speakup_list__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_firebase__ = __webpack_require__(3);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    _speakups: 'speakup/getSpeakUps'
  }), {
    speakups: function speakups() {
      return this._speakups.map(function (speakup, index) {
        switch (index % 3) {
          case 0:
            speakup.cor1 = '#E12F67';
            speakup.cor2 = '#8D00FF';
            break;
          case 1:
            speakup.cor1 = '#00F0FF';
            speakup.cor2 = '#6FBE15';
            break;
          case 2:
            speakup.cor1 = '#FF9C00';
            speakup.cor2 = '#FF0000';
            break;
          default:
            break;
        }

        return speakup;
      });
    }
  }),
  components: {
    list: __WEBPACK_IMPORTED_MODULE_4__components_speakup_list__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])({
    setShowLoader: 'setShowLoader'
  }), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getSpeakUps: 'speakup/getSpeakUps'
  })),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setShowLoader(true);

              _this.getSpeakUps().catch(function (error) {
                console.log(error);
              }).finally(function () {
                _this.setShowLoader(false);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 1209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(82);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list',
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    viewSpeakUp: function viewSpeakUp(speakup) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$router.push('/speakup/' + speakup.id);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getStatus: function getStatus(status) {
      switch (status) {
        case 'A':
          return 'Waiting';
        case 'I':
          return 'Initiated';
        case 'F':
          return 'Finished';
        default:
          return '';
      }
    },
    formatDate: function formatDate(date) {
      if (!date) return '';

      return new Date(date.split('.').shift()).toLocaleString();
    }
  }
});

/***/ }),

/***/ 1406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__(1209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a79a83f2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__(1409);
function injectStyle (ssrContext) {
  __webpack_require__(1407)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a79a83f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a79a83f2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1407:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("24495ec6", content, true, {});

/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".starenable[data-v-a79a83f2]{-webkit-filter:grayscale(0)!important;filter:grayscale(0)!important}.presential[data-v-a79a83f2]{background:#00c6ff;background:-webkit-gradient(linear,right top,left top,from(#00c6ff),color-stop(73%,#035bcd),to(#0435bb));background:linear-gradient(-90deg,#00c6ff,#035bcd 73%,#0435bb)}.container--unit[data-v-a79a83f2]{padding:7px 13px;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:25px;position:relative}.container--unit .container--unit__box[data-v-a79a83f2]{background:#fff;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.08),0 6px 7px 0 rgba(0,0,0,.04);box-shadow:0 2px 4px 0 rgba(0,0,0,.08),0 6px 7px 0 rgba(0,0,0,.04);border-radius:20px;-webkit-box-sizing:border-box;box-sizing:border-box;border:2px solid #525252;text-align:center;-webkit-transition:.3s;transition:.3s;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.container--unit .container--unit__box[data-v-a79a83f2]:hover{-webkit-transform:scale(1.06);transform:scale(1.06);background:#dfdfdf;-webkit-box-shadow:5px 5px 5px 1px rgba(0,0,0,.2);box-shadow:5px 5px 5px 1px rgba(0,0,0,.2)}.container--unit .container--unit__box .container--unit__title[data-v-a79a83f2]{font-size:14px;text-align:center;color:#717171}.container--unit .container--unit__box .container--unit__star[data-v-a79a83f2]{margin:10px 0}.container--unit .container--unit__box .container--unit__star img[data-v-a79a83f2]{-webkit-filter:grayscale(100%);filter:grayscale(100%);margin-left:5px}.container--unit .container--unit__box .container--unit__btn[data-v-a79a83f2]{margin:20px 0 10px}.container--unit .container--unit__box .container--unit__ball[data-v-a79a83f2]{width:105px;height:55px;margin-top:-20px;border-radius:15px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;text-align:center}.container--unit .container--unit__box .container--unit__ball span[data-v-a79a83f2]{font-size:15px;font-weight:300}.container--unit .container--unit__box .container--unit__ball h3[data-v-a79a83f2]{font-size:40px;margin-left:5px;font-weight:400}.container--unit__cover[data-v-a79a83f2]{cursor:not-allowed;position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:100%;height:calc(100% + 40px);bottom:0;right:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:hsla(0,0%,95%,.5)}.container--unit__cover:hover svg[data-v-a79a83f2]{width:85px;height:85px;color:#c43232;background:rgba(232,76,76,.5);padding:5px;border-radius:50px}.container--unit__cover svg[data-v-a79a83f2]{width:80px;height:80px;margin-top:20px;color:#7f7f7f;-webkit-transition:all .2s;transition:all .2s;background:hsla(0,0%,95%,.5);padding:5px;border-radius:50px}.container--unit__cover p[data-v-a79a83f2]{background:#ffffffbf;padding:6px 30px;border-radius:30px;color:#e84c4c}.disabled[data-v-a79a83f2],.disabled [data-v-a79a83f2]{cursor:not-allowed}.speakup_status[data-v-a79a83f2]{margin:5px 0}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/speakup/list.vue"],"names":[],"mappings":"AACA,6BACE,sCAAyC,AACjC,6BAAiC,CAC1C,AACD,6BACE,mBAAoB,AACpB,yGAAgH,AAChH,8DAA2E,CAC5E,AACD,kCACE,iBAAkB,AAClB,8BAA+B,AACvB,sBAAuB,AAC/B,gBAAiB,AACjB,iBAAmB,CACpB,AACD,wDACI,gBAAoB,AACpB,2EAAqF,AAC7E,mEAA6E,AACrF,mBAAoB,AACpB,8BAA+B,AACvB,sBAAuB,AAC/B,yBAA0B,AAC1B,kBAAmB,AACnB,uBAAyB,AACzB,eAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAgB,CACnB,AACD,8DACM,8BAA+B,AACvB,sBAAuB,AAC/B,mBAAoB,AACpB,kDAAuD,AAC/C,yCAA+C,CAC5D,AACD,gFACM,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CACpB,AACD,+EACM,aAAiB,CACtB,AACD,mFACQ,+BAAgC,AACxB,uBAAwB,AAChC,eAAiB,CACxB,AACD,8EACM,kBAA0B,CAC/B,AACD,+EACM,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAY,AACZ,iBAAmB,CACxB,AACD,oFACQ,eAAgB,AAChB,eAAiB,CACxB,AACD,kFACQ,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CACxB,AACD,yCACI,mBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,6BAA8B,AAClC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAY,AACZ,yBAA0B,AAC1B,SAAU,AACV,QAAS,AACT,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,kCAA2C,CAC9C,AACD,mDACM,WAAY,AACZ,YAAa,AACb,cAAe,AACf,8BAAmC,AACnC,YAAa,AACb,kBAAoB,CACzB,AACD,6CACM,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,cAAe,AACf,2BAA4B,AAC5B,mBAAoB,AACpB,6BAAqC,AACrC,YAAa,AACb,kBAAoB,CACzB,AACD,2CACM,qBAAsB,AACtB,iBAAkB,AAClB,mBAAoB,AACpB,aAAe,CACpB,AACD,uDACE,kBAAoB,CACrB,AACD,iCACE,YAAc,CACf","file":"list.vue","sourcesContent":["\n.starenable[data-v-a79a83f2] {\n  -webkit-filter: grayscale(0%) !important;\n          filter: grayscale(0%) !important;\n}\n.presential[data-v-a79a83f2] {\n  background: #00C6FF;\n  background: -webkit-gradient(linear, right top, left top, from(#00C6FF), color-stop(73%, #035BCD), to(#0435BB));\n  background: linear-gradient(-90deg, #00C6FF 0%, #035BCD 73%, #0435BB 100%);\n}\n.container--unit[data-v-a79a83f2] {\n  padding: 7px 13px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-top: 25px;\n  position: relative;\n}\n.container--unit .container--unit__box[data-v-a79a83f2] {\n    background: #FFFFFF;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 6px 7px 0 rgba(0, 0, 0, 0.04);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 6px 7px 0 rgba(0, 0, 0, 0.04);\n    border-radius: 20px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 2px solid #525252;\n    text-align: center;\n    -webkit-transition: 0.3s;\n    transition: 0.3s;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    cursor: pointer;\n}\n.container--unit .container--unit__box[data-v-a79a83f2]:hover {\n      -webkit-transform: scale(1.06);\n              transform: scale(1.06);\n      background: #dfdfdf;\n      -webkit-box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);\n              box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);\n}\n.container--unit .container--unit__box .container--unit__title[data-v-a79a83f2] {\n      font-size: 14px;\n      text-align: center;\n      color: #717171;\n}\n.container--unit .container--unit__box .container--unit__star[data-v-a79a83f2] {\n      margin: 10px 0px;\n}\n.container--unit .container--unit__box .container--unit__star img[data-v-a79a83f2] {\n        -webkit-filter: grayscale(100%);\n                filter: grayscale(100%);\n        margin-left: 5px;\n}\n.container--unit .container--unit__box .container--unit__btn[data-v-a79a83f2] {\n      margin: 20px 0px 10px 0px;\n}\n.container--unit .container--unit__box .container--unit__ball[data-v-a79a83f2] {\n      width: 105px;\n      height: 55px;\n      margin-top: -20px;\n      border-radius: 15px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      color: #fff;\n      text-align: center;\n}\n.container--unit .container--unit__box .container--unit__ball span[data-v-a79a83f2] {\n        font-size: 15px;\n        font-weight: 300;\n}\n.container--unit .container--unit__box .container--unit__ball h3[data-v-a79a83f2] {\n        font-size: 40px;\n        margin-left: 5px;\n        font-weight: 400;\n}\n.container--unit__cover[data-v-a79a83f2] {\n    cursor: not-allowed;\n    position: absolute;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    width: 100%;\n    height: calc(100% + 40px);\n    bottom: 0;\n    right: 0;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    background-color: rgba(243, 243, 243, 0.5);\n}\n.container--unit__cover:hover svg[data-v-a79a83f2] {\n      width: 85px;\n      height: 85px;\n      color: #c43232;\n      background: rgba(232, 76, 76, 0.5);\n      padding: 5px;\n      border-radius: 50px;\n}\n.container--unit__cover svg[data-v-a79a83f2] {\n      width: 80px;\n      height: 80px;\n      margin-top: 20px;\n      color: #7f7f7f;\n      -webkit-transition: all .2s;\n      transition: all .2s;\n      background: rgba(243, 243, 243, 0.5);\n      padding: 5px;\n      border-radius: 50px;\n}\n.container--unit__cover p[data-v-a79a83f2] {\n      background: #ffffffbf;\n      padding: 6px 30px;\n      border-radius: 30px;\n      color: #e84c4c;\n}\n.disabled[data-v-a79a83f2], .disabled *[data-v-a79a83f2] {\n  cursor: not-allowed;\n}\n.speakup_status[data-v-a79a83f2] {\n  margin: 5px 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container wrap"},_vm._l((_vm.data.sort(function (a, b) { return (new Date(a.date).getTime() - new Date().getTime(a.date)); })),function(x,index){return _c('div',{key:index,staticClass:"animation-bottom container--unit col-12 col-xl-3 col-lg-4 col-md-6 col-sm-12",style:({animationDelay: (index / 10) + 's'}),on:{"click":function($event){return _vm.viewSpeakUp(x)}}},[_c('div',{staticClass:"container--unit__box"},[_c('div',{staticClass:"container--unit__ball container",style:({background: 'linear-gradient(-45deg,' + x.cor1 + ' 0% , ' + x.cor2 + ') 100% '})},[_c('span',{staticClass:"span-unit"},[_vm._v(_vm._s(x.book_name))])]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(x.lesson_name))]),_vm._v(" "),_c('h5',[_vm._v("Order: "+_vm._s(x.lesson_order))]),_vm._v(" "),_c('h6',{staticClass:"speakup_status"},[_vm._v(_vm._s(_vm.formatDate(x.date)))]),_vm._v(" "),_c('h4',{staticClass:"speakup_status"},[_vm._v(_vm._s(_vm.getStatus(x.status)))]),_vm._v(" "),_vm._m(0,true)])])}),0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container--unit__btn container align-items-center justify-content-center"},[_c('button',{staticClass:"btn btn-rounded color-white btn-sm gradient-start",attrs:{"type":"button","name":"button"}},[_vm._v("VIEW")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"box-content--header container align-items-center justify-content-center hidden"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-content--header__text flex-grow-1 flex-basis-400"},[_c('div',{staticClass:"container"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"margin-left-20 margin-right-10 container aling-items-end animation-top animation-delay-04"},[_c('button',{staticClass:"btn btn-sm btn-rounded gradient-yellow btn-padding",staticStyle:{"color":"rgb(196, 0, 60)"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Voltar")])])]),_vm._v(" "),_c('hr',{staticClass:"header-text-hr animation-top animation-delay-02",staticStyle:{"width":"167px"}}),_vm._v(" "),_c('p',{staticClass:"animation-bottom animation-delay-04"},[_vm._v("Veja todas suas Speak Ups! ")])])]),_vm._v(" "),_c('div',{staticClass:"box-content shadow-box box-content-border"},[_c('list',{attrs:{"data":_vm.speakups}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content--header__img"},[_c('div',{staticClass:"img1 container align-items-center justify-content-center animation-bottom"},[_c('div',{staticClass:"img2 container align-items-center justify-content-center"},[_c('img',{attrs:{"src":__webpack_require__(668),"width":"50","alt":"Minds"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"animation-top animation-delay-02"},[_vm._v("YOUR "),_c('span',[_vm._v("SPEAK UP")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_speakups_vue__ = __webpack_require__(1208);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e16a0c6a_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_speakups_vue__ = __webpack_require__(1410);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_speakups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e16a0c6a_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_speakups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 668:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// static/js/51.3a8cd9dc0a2c704be50f.js